export enum EAttachmentFile {
  ACCEPT_FILE_TYPE = 'image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  FILE_SIZE_EXCEEDS_LIMIT = 100,
  FILE_NUMBER_EXCEEDS_LIMIT = 50,
  FILE_SIZE_EXCEEDS_LIMIT_MESSAGE = 'このファイルはアップロード容量を超えています ( 100MBまで)',
  FILE_NUMBER_EXCEEDS_LIMIT_MESSAGE = 'このナレッジにはこれ以上ファイルを追加できません。 (最大50ファイルまで)'
}
